import { useCallback } from 'react';

import useScrolling from './druid/useScrolling';
import useScrollTo from './druid/useScrollTo';
import useStyleOptions from './druid/useStyleOptions';
import useTimeout from '/druid/useTimeout';

export default function useAutoCenter() {
  const [{ autoCenter }] = useStyleOptions();
  const [scrolling] = useScrolling();
  const scrollTo = useScrollTo();

  const handleTrigger = useCallback(() => scrollTo(({ index }) => index), [scrollTo]);

  useTimeout(!autoCenter || scrolling ? undefined : handleTrigger, 0);
}
